import React from 'react';
import {FormModal} from 'components/modals';
import StoryboardSettingsForm from './StoryboardSettingsForm';
import {withTranslation, WithTranslation} from 'react-i18next';
import i18n from 'i18n';

interface StoryboardData {
    title: string;
    id: number;
}

interface ModalProps {
    show: boolean;
    onHide: () => void;
}

interface StoryboardSettingsModalProps extends WithTranslation {
    modalProps: ModalProps;
    storyboardData: StoryboardData;
    onSave: (data: StoryboardData) => void;
}

class StoryboardSettingsModal extends React.PureComponent<StoryboardSettingsModalProps> {

    render() {
        const {modalProps, storyboardData, onSave} = this.props;

        return (
            <FormModal
                isOpen={modalProps.show}
                onClose={modalProps.onHide}
                title={i18n.t('jt_storyboard_settings.text')}
            >
                <StoryboardSettingsForm
                    storyboardId={storyboardData.id}
                    initialData={storyboardData}
                    onSave={onSave}
                />
            </FormModal>
        );
    }
}

export default withTranslation()(StoryboardSettingsModal);
